import type { EvaluationTypeValue } from '@/constants/cycle-evaluation/CycleEvaluation';
import type { CycleInstance } from '@/types/cycle-evaluation/CycleInstance';

import { api } from '@/api/api';

interface GetCycleInstanceOptions {
    includeInactiveQuestions?: boolean;
}

export default {
    async createCycleInstance(reviewType: EvaluationTypeValue): Promise<CycleInstance> {
        const response = await api.post('/cycleinstance', { reviewType });

        return response.data;
    },
    async deleteCycleInstance(cycleInstanceId: string) {
        const response = await api.delete(`/cycleinstance/${cycleInstanceId}`);

        return response.data;
    },

    async launchCycleInstance(cycleInstanceId: string): Promise<void> {
        await api.post(`/cycleinstance/${cycleInstanceId}/launch`);
    },

    async getCycleInstance(
        cycleInstanceId: string,
        options?: GetCycleInstanceOptions,
    ): Promise<CycleInstance> {
        const response = await api.get(`/cycleinstance/${cycleInstanceId}`, {
            params: {
                includeInactiveQuestions: options?.includeInactiveQuestions || undefined,
            },
        });

        return response.data;
    },
};
